module.exports = __webpack_public_path__ + "media/images/contact-bg-1024-6db052f41adb2f650c9e37f3edfd22d1.png";